import { Component, input, OnInit } from '@angular/core';
import { faFire, faChevronRight, faFileLines, faMessage } from '@fortawesome/free-solid-svg-icons';
import { MatTableDataSource } from '@angular/material/table';
import { ReportService } from 'src/app/services/report.service';
import { forkJoin } from 'rxjs';

@Component({
    selector: 'coor-assignments',
    templateUrl: './coor-assignments.component.html',
    styleUrls: ['./coor-assignments.component.scss'],
    standalone: false
})


export class CoorAssignmentsComponent implements OnInit {
  //icons
  faFire = faFire;
  faChevronRight = faChevronRight;
  faFileLines = faFileLines;
  faMessage = faMessage;

  //table variables
  reports = new MatTableDataSource<any>();
  rawReports: any;
  report_count = 0;
  displayedColumns = [
    'name',
    'reportId',
    'action_type',
    'report_type',
    'report_status',
    'auth_status',
    'comments',
    'action'
  ];
  reportCount = 5;

  //dropdown lists
  regions: any;
  statuses: any;
  complexities: any;
  team_leads: any;
  yearsArray: any;

  //access
  user = input.required<any>();

  constructor(
    private readonly reportsService: ReportService,
  ) {
  }

  ngOnInit(): void {
    this.loadReportData();

  }

  loadReportData() {
    let reportRelations = '&relations=users.skills,assessment,comments';

      forkJoin({
        data1: this.reportsService.getReportListByStatus(reportRelations, 3, null),
        data3: this.reportsService.getReportListByStatus(reportRelations, 2, 3),
        data5: this.reportsService.getReportListByStatus(reportRelations, 2, 5)
      }).subscribe(
      {
        next: ({data1, data3, data5}) => {
          let data = data1.reports;
          if (this.user().isROCO) //REVIEW RO FUNDING
            data = [...data, ...data3.reports]
          if (this.user().isWOCO) //REVIEW WO FUNDING
            data = [...data, ...data5.reports]

          let reports = this.filterReports(data ?? []);
          this.setReportComments(reports);
          reports.sort((reportA: any, reportB: any) => reportB.report_id - reportA.report_id);
          this.rawReports = reports;
          this.report_count = reports.length;
          reports = reports.slice(0, this.reportCount);
          this.reports.data = reports;
        }
      });
  }

  setReportComments(reports: any) {
    reports.forEach((report: any) => {
      let findUnresolved = report.comments.find((x: any) => !x.resolved)
      if (findUnresolved ?? false) report.comments_unresolved = true;
    });
  }

  filterReports(reports: any) {
    if (this.user().isROCO && !this.user().isWOCO) {
      reports = reports.filter((report: any) => report.region.includes(this.user().isROCO));
    }
    return reports;
  }

  loadMore() {
    this.reportCount += 5;
    this.reports.data = this.rawReports.slice(0, this.reportCount);
  }
}